// Semáforo de cumplimiento — criterio único del coordinador.
//
// Antes cada pantalla definía su propio umbral: C1/C7/C9/AnalisisParos usaban
// 60/85 y C5/LineaTiempo usaban 90/70. La MISMA línea al 80% se veía distinta
// según la pantalla. Esto unifica el criterio a 90/70 (el de las pantallas
// nuevas) y lo expone como helper compartido.
//
// NO incluye el modal LineaHoraAHoraDialog, que usa 95/80 a propósito: ahí el %
// es de cumplimiento POR HORA (más exigente), no del período agregado.

/** Tono semántico de un valor de cumplimiento. */
export type Tone = 'ok' | 'warn' | 'crit' | 'neutral';

// DN5 (responsable 2026-09-07): dos dominios, dos umbrales, cada semáforo
// muestra su regla al lado.
//   - Operación (cumplimiento de meta, de programa, líderes, Pits vs meta):
//     verde ≥ 90 · ámbar 70–89 · rojo < 70. Es capacidad estándar: el 100 % no
//     es exigible hora a hora.
//   - Compromiso comercial (nivel de servicio, cruce de facturación vs
//     programado): verde ≥ 95 · ámbar 90–94 · rojo < 90. Lo pactado con el
//     cliente se cumple o no.

/** Texto de la regla del semáforo de OPERACIÓN, para mostrar junto al valor. */
export const REGLA_SEMAFORO_OPERACION = 'verde ≥ 90 % · ámbar 70–89 % · rojo < 70 %';
/** Texto de la regla del semáforo COMERCIAL, para mostrar junto al valor. */
export const REGLA_SEMAFORO_COMERCIAL = 'verde ≥ 95 % · ámbar 90–94 % · rojo < 90 %';

/** Semáforo de OPERACIÓN sobre % de cumplimiento: verde ≥90, ámbar 70-89, rojo <70, gris si null. */
export function semaforoCumplimiento(pct: number | null | undefined): Tone {
  if (pct === null || pct === undefined) return 'neutral';
  if (pct >= 90) return 'ok';
  if (pct >= 70) return 'warn';
  return 'crit';
}

/** Semáforo COMERCIAL (compromiso con el cliente): verde ≥95, ámbar 90-94, rojo <90, gris si null. */
export function semaforoComercial(pct: number | null | undefined): Tone {
  if (pct === null || pct === undefined) return 'neutral';
  if (pct >= 95) return 'ok';
  if (pct >= 90) return 'warn';
  return 'crit';
}

/** Clase de texto Tailwind para un tono (text-ok/warn/crit, gris si neutral). */
export function toneTextClass(tone: Tone): string {
  switch (tone) {
    case 'ok':
      return 'text-ok';
    case 'warn':
      return 'text-warn';
    case 'crit':
      return 'text-crit';
    default:
      return 'text-fg-tertiary';
  }
}
